import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type { Plugin } from './plugin'

export class Selectors {
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly actionRenderingLookup

  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getActionRendering
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly getActionRawRendering

  // NOTE: intentionally not typed here so that type can be inferred
  public readonly currentActionRendering
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly currentActionRawRendering

  constructor(plugin: Plugin) {
    this.actionRenderingLookup = plugin.feature.state.project(
      state => state.actionRenderingLookup,
    )

    const getLookupEntry = plugin.feature.createSelectorMethod(
      (id: ec.models.EntityId) =>
        this.actionRenderingLookup.project(lookup => lookup[id]).asSelector,
    )
    this.getActionRendering = plugin.feature.createSelectorMethod(
      (id: ec.models.EntityId) =>
        getLookupEntry(id).project(entry => entry?.rendering).asSelector,
    )
    this.getActionRawRendering = plugin.feature.createSelectorMethod(
      (id: ec.models.EntityId) =>
        getLookupEntry(id).project(entry => entry?.rawRendering).asSelector,
    )

    const currentActionLookupEntry = this.actionRenderingLookup.project(
      plugin.collection.plugins.currentEntityPlugin.feature.selectors.getId()
        .asSelector,
      (lookup, id) => (id ? lookup[id] : undefined),
    )
    this.currentActionRendering = currentActionLookupEntry.project(
      entry => entry?.rendering,
    )
    this.currentActionRawRendering = currentActionLookupEntry.project(
      entry => entry?.rawRendering,
    )
  }
}
